(() => {
  function initBackInStockButton(button) {
    if (button.dataset.backInStockBound) return;

    // The sticky bar renders its button from the layout, where section.id is blank: it opens the buy box's modal.
    const modal =
      document.getElementById(button.dataset.modalId) || document.querySelector("[data-back-in-stock-modal]");
    if (!modal) return;
    button.dataset.backInStockBound = "true";

    const form = modal.querySelector("[data-back-in-stock-form]");
    const emailInput = form.querySelector('input[name="email"]');
    const variantIdInput = form.querySelector('input[name="variant_id"]');
    const infoText = modal.querySelector("[data-back-in-stock-info]");
    const infoTextSpan = modal.querySelector("[data-back-in-stock-info] > span");
    const successMessage = modal.querySelector("[data-back-in-stock-success]");
    const successMessageSpan = modal.querySelector("[data-back-in-stock-success] > span");
    const errorMessage = modal.querySelector("[data-back-in-stock-error]");

    function displayElement(element, show) {
      element.style.display = show ? "block" : "none";
    }

    function checkAvailability(isAvailable) {
      button.classList.toggle("klaviyo-back-in-stock__button--visible", !isAvailable);
      displayElement(button, !isAvailable);
    }

    function updateModalContent(variantTitle) {
      const decodedVariantTitle = new DOMParser().parseFromString(variantTitle, "text/html").body.textContent;

      // Single-variant products are titled "Default Title"; show the product title alone.
      const cleanedVariantTitle = decodedVariantTitle === "Default Title" ? "" : decodedVariantTitle;
      const productTitle = button.dataset.productTitle;
      const fullTitle = cleanedVariantTitle ? productTitle + " - " + cleanedVariantTitle : productTitle;

      if (infoTextSpan) infoTextSpan.textContent = fullTitle;
      if (successMessageSpan) successMessageSpan.textContent = fullTitle;
    }

    function updateBackInStockFormVariant(variantId) {
      variantIdInput.value = variantId;
    }

    function handleSubmit(event) {
      event.preventDefault();

      const email = emailInput.value;
      const variantId = variantIdInput.value;
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: { data: { type: "catalog-variant", id: `$shopify:::$default:::${variantId}` } },
          },
        },
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WNbFKg`, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2023-12-15" },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          displayElement(successMessage, true);
          displayElement(infoText, false);
          displayElement(errorMessage, false);
          displayElement(form, false);

          if (window.klaviyo && typeof window.klaviyo.identify === "function") {
            window.klaviyo.identify({
              email: email,
              locale: button.dataset.locale,
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          displayElement(successMessage, false);
          displayElement(errorMessage, true);
        });
    }

    button.addEventListener("click", (event) => {
      event.preventDefault();

      displayElement(successMessage, false);
      displayElement(errorMessage, false);
      displayElement(form, true);
      displayElement(infoText, true);
      modal.setAttribute("open", "true");
    });

    // The buy box and the sticky bar share one modal; only one of them may submit it.
    if (!form.dataset.bound) {
      form.dataset.bound = "true";
      form.addEventListener("submit", handleSubmit);
    }

    checkAvailability(button.dataset.variantAvailable === "true");
    updateModalContent(button.dataset.variantTitle);
    updateBackInStockFormVariant(button.dataset.variantId);

    subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
      checkAvailability(data.data.variant.available);
      updateModalContent(data.data.variant.title);
      updateBackInStockFormVariant(data.data.variant.id);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-back-in-stock-button]").forEach(initBackInStockButton);
  });
})();
